import React, { useEffect } from "react";
import PublicMainNav from "@/components/PublicMainNav";
import FooterAdmin from "@/components/FooterAdmin";

const AdminPublicLayout = ({ children }: { children: React.ReactNode }) => {

    useEffect(() => {
    }, []);

    return (
        <div className="min-h-screen flex flex-col bg-gray-50">
            {/* Navigation */}
            <PublicMainNav />

            {/* Main Content */}
            <main className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                {children}
            </main>

            {/* Footer */}
            <FooterAdmin />
        </div>
    );
};

export default AdminPublicLayout;
